export enum IndexType {
  Municipality = 'municipality',
  RegionAll = 'regionAll',
  ProvinceAll = 'provinceAll',
  Category = 'category',
}
